(function () {
  const initCCG = () => {
    const sections = document.querySelectorAll('.ccg-section');
    sections.forEach((section) => {
      if (section.dataset.ccgInit === 'true') return;
      section.dataset.ccgInit = 'true';

      const sectionId = section.dataset.sectionId;
      if (!sectionId) return;

      // FAQ accordion
      const toggles = section.querySelectorAll('.ccg-faq-item__toggle');
      toggles.forEach((toggle) => {
        toggle.addEventListener('click', function () {
          const item = this.closest('.ccg-faq-item');
          const descWrap = item.querySelector('.ccg-faq-item__desc-wrap');
          const isExpanded = item.classList.contains('ccg-faq-item--expanded');

          if (isExpanded) {
            item.classList.remove('ccg-faq-item--expanded');
            this.setAttribute('aria-expanded', 'false');
            if (descWrap) descWrap.hidden = true;
          } else {
            item.classList.add('ccg-faq-item--expanded');
            this.setAttribute('aria-expanded', 'true');
            if (descWrap) descWrap.hidden = false;
          }
        });
      });

      // Nav scroll + indicator
      const navLinks = section.querySelectorAll('.ccg-nav__link');
      const groups = section.querySelectorAll('.ccg-group');
      const indicator = section.querySelector('.ccg-nav__indicator');
      const navList = section.querySelector('.ccg-nav__list');

      if (navLinks.length === 0 || groups.length === 0) return;

      const updateIndicator = (linkOrIndex) => {
        const link = typeof linkOrIndex === 'number' ? navLinks[linkOrIndex] : linkOrIndex;
        if (!link || !indicator) return;

        const track = indicator.closest('.ccg-nav__track');
        const trackRect = track ? track.getBoundingClientRect() : { left: 0, top: 0 };
        const linkRect = link.getBoundingClientRect();

        const isMobile = window.innerWidth < 1024;
        if (isMobile) {
          // 移动端：indicator 宽度 = link 宽度；left = link.offsetLeft - navList.scrollLeft
          const list = navList;
          const scrollLeft = list ? list.scrollLeft : 0;
          const offsetLeft = link.offsetLeft - scrollLeft;

          indicator.style.width = `${link.offsetWidth}px`;
          indicator.style.height = '3px';
          indicator.style.left = `${offsetLeft}px`;
          indicator.style.top = 'auto';
          indicator.style.bottom = '0';
        } else {
          indicator.style.width = '3px';
          indicator.style.height = `${linkRect.height}px`;
          indicator.style.left = '-0.15rem';
          indicator.style.top = `${linkRect.top - trackRect.top}px`;
          indicator.style.bottom = 'auto';
        }

        const idx = Array.from(navLinks).indexOf(link);
        navLinks.forEach((l, i) => l.classList.toggle('ccg-nav__link--active', i === idx));
      };

      const scrollToGroup = (targetId) => {
        const target = section.querySelector(`#${targetId}`);
        if (!target) return;

        const headerOffset = 80;
        const targetPos = target.getBoundingClientRect().top + window.scrollY - headerOffset;

        window.scrollTo({ top: targetPos, behavior: 'smooth' });
      };

      const scrollNavToLink = (link) => {
        if (!navList || window.innerWidth >= 1024) return;
        const listRect = navList.getBoundingClientRect();
        const linkRect = link.getBoundingClientRect();
        const linkCenter = linkRect.left - listRect.left + linkRect.width / 2;
        const listCenter = listRect.width / 2;
        const scrollTarget = navList.scrollLeft + linkCenter - listCenter;
        navList.scrollTo({ left: Math.max(0, scrollTarget), behavior: 'smooth' });
      };

      navLinks.forEach((link) => {
        link.addEventListener('click', () => {
          const targetId = link.dataset.targetId;
          if (targetId) scrollToGroup(targetId);
          updateIndicator(link);
          scrollNavToLink(link);
        });
      });

      // IntersectionObserver: sync nav active state when scrolling
      const observerOptions = { rootMargin: '-15% 0px -75% 0px', threshold: 0 };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const group = entry.target;
          const targetId = group.id;
          const activeLink = section.querySelector(`.ccg-nav__link[data-target-id="${targetId}"]`);
          if (activeLink) {
            updateIndicator(activeLink);
            scrollNavToLink(activeLink);
          }
        });
      }, observerOptions);

      groups.forEach((g) => observer.observe(g));

      // 当用户手动横向滚动导航时，保持 indicator 跟随当前激活项
      if (navList) {
        navList.addEventListener('scroll', () => {
          if (window.innerWidth >= 1024) return;
          const active = section.querySelector('.ccg-nav__link--active');
          if (active) updateIndicator(active);
        });
      }

      // Initial indicator
      const activeLink = section.querySelector('.ccg-nav__link--active') || navLinks[0];
      if (activeLink) updateIndicator(activeLink);

      // Update on resize (breakpoint change)
      let resizeTimer;
      const onResize = () => {
        if (!document.contains(section)) {
          window.removeEventListener('resize', onResize);
          return;
        }
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const link = section.querySelector('.ccg-nav__link--active') || navLinks[0];
          if (link) updateIndicator(link);
        }, 150);
      };
      window.addEventListener('resize', onResize);
    });
  };

  document.addEventListener('shopify:section:load', initCCG);
  document.addEventListener('DOMContentLoaded', () => initCCG());

  if (document.readyState !== 'loading') {
    initCCG();
  }
})();
